<template>
<div class="chapter">
<div class="inner_page">
<h1 id="sigil_toc_id_2" title="Title Page"></h1>
<p class="tp2">EVANGELICAL<br/>
<span class="large">POSTCOLONIAL</span><br/>
  CONVERSATIONS</p>
<p class="tp3">Global Awakenings in Theology and Praxis</p>
<div class="picture"><img alt="" class="shrule" src="Images/TP.jpg"/></div>
<p class="tp4">Edited by<br/>
  Kay Higuera Smith, Jayachitra Lalitha<br/>
  and L. Daniel Hawk</p>
<div class="picns"><img alt="" class="chrule" src="Images/IVP_Academic_Quarter.jpg"/></div>
<p class="center"><a href="http://www.ivpress.com/academic/" target="_blank">www.ivpress.com/academic</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?1e6bff5b